export default "__VITE_ASSET__B00Lb26G__"